import React, { lazy } from 'react';
import { Route } from 'react-router-dom';

import ProtectedRoute from 'src/views/protectedRoute';
import PublicRoute from 'src/views/publicRoute';
import RouterErrorBoundary from 'src/RouterErrorBoundary';

import ModelSelectView from 'src/views/model-select-view/modelSelectView';

const AdminViewRoot = lazy(() => import(/* webpackChunkName: "adminroot" */ 'src/views/admin-view/adminRoot'));
const ModelViewContainer = lazy(() =>
	import(/* webpackChunkName: "modelviewcontainer" */ 'src/views/model-view/modelViewContainer')
);

const LoginView = lazy(() => import(/* webpackChunkName: "login" */ 'src/views/loginView'));
const SetPasswordView = lazy(() => import(/* webpackChunkName: "setpassword" */ 'src/views/setPasswordView'));
const UserProfileView = lazy(() =>
	import(/* webpackChunkName: "userprofile" */ 'src/views/user-profile-view/userProfileView')
);
const ConfirmNewMailView = lazy(() => import(/* webpackChunkName: "confirmmail" */ 'src/views/confirmNewEmail'));

const ImpressumView = lazy(() => import(/* webpackChunkName: "impressum" */ 'src/views/impressum'));
const PrivacyView = lazy(() => import(/* webpackChunkName: "privacy" */ 'src/views/privacy'));

export default (
	<Route path='/' errorElement={<RouterErrorBoundary />}>
		<Route path='' element={<PublicRoute />}>
			<Route path='login' element={<LoginView />} />
			<Route path='registration' element={<SetPasswordView />} />
			<Route path='resetPassword' element={<SetPasswordView />} />
			<Route path='confirmNewMail' element={<ConfirmNewMailView />} />
			<Route path='modelSelect' element={<ModelSelectView />} />
			<Route path='impressum' element={<ImpressumView />} />
			<Route path='privacy' element={<PrivacyView />} />
			<Route path='' element={<ModelSelectView />} />
			<Route path='model/:modelSlug/view/:viewId/project?/:projectId?' element={<ModelViewContainer />} />
		</Route>
		<Route path='' element={<ProtectedRoute />}>
			<Route path='userProfile' element={<UserProfileView />} />
			<Route path='adminView/*' element={<AdminViewRoot />} />
		</Route>
	</Route>
);
